/* eslint-disable no-unused-vars */
import React, {PureComponent} from 'react';
import {   Button,  } from 'semantic-ui-react'
import _ from 'lodash';

export default class StyleControls extends PureComponent {

  _onClick = (n) => {
    const { onNotificationClick } = this.props;
    let notifications = this.props.notifications;
    _.remove(notifications,n);
    // console.log('notifications',notifications)

    onNotificationClick(n,notifications)
  }

  render() {

    const { notifications } = this.props;


    return (

      <div style={{position: 'absolute', top: 20, left: 200, maxWidth: 300, maxHeight: '80%',overflow: 'auto'}}>

      {
        _.map(notifications, (n, i) => {
          // console.log(n)
          return (
            <Button key={i} circular icon='bell' style={{backgroundColor: n.properties.color, color: 'white' }} onClick={() => this._onClick(n) } />
          );
        })
      }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/Dashboard/v3/notifications.js